import { useGlobalContext } from "../../../../../../Context/Context";
import { useEffect, useState } from "react";
import Button from "../../../../../Custom/Button/Button";
import PodaciKompanije from "./PodaciKompanije";
import TabelaOpreme from "./TabelaOpreme";
import DodavanjeSredstva from "./DodavanjeSredstva";
import { generisiPDF } from "./generisiPDF";

const styles = {
  button: {
    padding: "5px 30px",
    fontWeight: "bold"
  },
  text: {
    width: "100%",
    padding: "5px",
    resize: "vertical",
    fontFamily: "inherit",
    fontSize: "14px",
    border: "1px solid #ccc",
    borderRadius: "3px"
  },
  label: {
    fontWeight: "bold",
    textTransform: "uppercase",
    marginBottom: "3px",
    fontSize: "12px"
  }
};

const initialData = {
  text: `Поштовани,\nдоставите нам понуду за преглед и проверу средстава и опреме за рад која су наведена:`,
  sredstva: [],
  contactData: ""
};

function ZahtevZaPregledProveru({ setCurrentState }) {
  const [isDodavanje, setIsDodavanje] = useState(false);
  const [data, setData] = useState(initialData);
  const [sredstvaAll, setSredstvaAll] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSendingPDF, setIsSendingPDF] = useState(false);

  const { dictionary, setIsZahtevZaPregledSredstva, selectedMainEntity } = useGlobalContext();

  // Učitaj sve aktivne mašine za ovu firmu
  useEffect(() => {
    const fetchSredstva = async () => {
      if (!selectedMainEntity?.company_id) return;
      setIsLoading(true);
      try {
        const response = await fetch("https://data.nadzor.app/api/machines/read_machines.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            company_id: selectedMainEntity.company_id,
            status_filter: "AKTIVNA"
          })
        });
        const result = await response.json();
        if (result.status === 200) {
          setSredstvaAll(result.data);
        }
      } catch (err) {
        console.error("Greška pri učitavanju sredstava:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSredstva();
  }, [selectedMainEntity]);

  // Postavi kontakt podatke iz selectedMainEntity
  useEffect(() => {
    if (selectedMainEntity) {
      const kontakt = [
        selectedMainEntity.kontakt_osoba ? `Kontakt: ${selectedMainEntity.kontakt_osoba}` : null,
        selectedMainEntity.telefon ? `Telefon: ${selectedMainEntity.telefon}` : null,
        selectedMainEntity.email ? `Email: ${selectedMainEntity.email}` : null
      ]
        .filter(Boolean)
        .join("\n");

      setData(prev => ({ ...prev, contactData: kontakt }));
    }
  }, [selectedMainEntity]);

  const handleChangeText = (field, value) => {
    setData({ ...data, [field]: value });
  };

  const handleSend = async () => {
    if (isDisabledPosalji) return;
    setIsSendingPDF(true);
    try {
      await generisiPDF({
        kompanija: selectedMainEntity,
        text: data.text,
        sredstva: data.sredstva,
        contactData: data.contactData
      });
    } catch (err) {
      console.error("Greška pri generisanju PDF-a:", err);
    } finally {
      setIsSendingPDF(false);
    }
  };

  const handleDodajSredstvo = () => {
    setIsDodavanje(true);
  };

  const handleNazad = () => {
    setIsZahtevZaPregledSredstva(false);
    setCurrentState("AKTIVNA");
    window.dispatchEvent(
      new CustomEvent("machinesViewSync", {
        detail: { mode: "AKTIVNA" }
      })
    );
  };

  const isDisabledPosalji =
    !data.text || !data.contactData || data.sredstva.length === 0;

  return (
    <div
      style={{
        padding: "25px",
        backgroundColor: "#f9f9f9",
        height: "100%",
        border: "1.5px solid #9f9f9f",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <div
        style={{
          flex: 1,
          overflow: "auto",
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          gap: "10px"
        }}
      >
        <div style={{ fontWeight: "bold", textAlign: "center", fontSize: "15px" }}>
          <div>Захтев за преглед и проверу опреме за рад</div>
        </div>

        <PodaciKompanije kompanija={selectedMainEntity} />

        <div>
          <textarea
            value={data.text}
            onChange={(e) => handleChangeText("text", e.target.value)}
            rows={3}
            style={styles.text}
          />
        </div>

        {isLoading ? (
          <div style={{ textAlign: "center", padding: "10px", color: "#888" }}>
            Учитавање средстава...
          </div>
        ) : (
          <TabelaOpreme sredstva={data.sredstva} setData={setData} />
        )}

        <div>
          <div style={styles.label}>КОНТАКТ</div>
          <textarea
            value={data.contactData}
            onChange={(e) => handleChangeText("contactData", e.target.value)}
            rows={3}
            style={styles.text}
          />
        </div>
      </div>

      {isDodavanje ? (
        <DodavanjeSredstva
          sredstvaAll={sredstvaAll}
          setData={setData}
          setIsDodavanje={setIsDodavanje}
          selectedSredstva={data.sredstva}
        />
      ) : (
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
          <div onClick={handleNazad}>
            <Button activation={true} style={styles.button}>
              {dictionary["nazad"]}
            </Button>
          </div>
          <div style={{ display: "flex", gap: "10px" }}>
            <div onClick={handleDodajSredstvo}>
              <Button activation={true} style={styles.button}>
                {dictionary["dodajSredstvo"]}
              </Button>
            </div>
            <div
              onClick={handleSend}
              style={{ opacity: isDisabledPosalji || isSendingPDF ? 0.5 : 1 }}
            >
              <Button
                isDisabled={isDisabledPosalji || isSendingPDF}
                activation={true}
                style={styles.button}
              >
                {isSendingPDF ? "Генерисање..." : dictionary["posalji"]}
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ZahtevZaPregledProveru;